export default __webpack_public_path__ + "static/media/check.2a0a633d.svg";